import React, { useContext, useState } from 'react';
import { Typography, makeStyles, Box } from '@material-ui/core';
import StoryContext from '../../contexts/StoryContext';
import FiltersContext from '../../contexts/FiltersContext';
import QuestionHeaderBox from '../QuestionHeaderBox';
import Filters from './Filters';
import Map from './Map';
import { years } from '../../modules/years';

const StoryQ1 = () => {
  const { primaryColor } = useContext(StoryContext);
  const [settingType, setSettingType] = useState('All');
  const [childRace, setChildRace] = useState('All');
  const [acceptSubsidies, setAcceptSubsidies] = useState('All');
  const [qualityRating, setQualityRating] = useState({ name: 'All', codeValue: null });
  const [displayBy, setDisplayBy] = useState('Providers');

  const classes = makeStyles((theme) => ({
    question: {
      marginTop: theme.spacing(2),
      color: primaryColor,
    },
    contents: {
      textAlign: 'left',
      marginTop: theme.spacing(4),
    },
  }))();
  return (
    <>
      <QuestionHeaderBox color={primaryColor}>
        <Typography variant="h3" component="h2" align="center" className={classes.question} gutterBottom>
          How have individual neighborhoods been impacted by child care closures due to COVID-19?
        </Typography>
        <Typography variant="body1" align="left" style={{ marginTop: 10 }} gutterBottom>
          Many neighborhoods have been impacted including those with marginalized populations which are already being most impacted by this pandemic.
          Click on the map below to explore the change in the number of child care providers available as of {years.covidToMonthYear}.
        </Typography>

        <FiltersContext.Provider value={{
          settingType,
          setSettingType,
          childRace,
          setChildRace,
          acceptSubsidies,
          setAcceptSubsidies,
          qualityRating,
          setQualityRating,
          displayBy,
          setDisplayBy,
        }}
        >
          <Box displayPrint="none" className={classes.contents}>
            <Box displayPrint="none">
              <Filters />
            </Box>
          </Box>
          <Box className={classes.contents}>
            <Map />
          </Box>
        </FiltersContext.Provider>
      </QuestionHeaderBox>
    </>
  );
};

export default StoryQ1;
